import BsImage from '../icons/BsImage';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import '../styles/ProductGallery.css';
import ResponsiveImage from './ResponsiveImage';
import ParallaxModel from './ParallaxModal';
import ZoomableResponsiveImage from './ZoomableResponsiveImage';


const ProductGallery = ({images = [], product}) => {
    const [ activeIndex, setActiveIndex ] = useState(0);
    const [showModal, setShowModal] = useState(false);

    // show modal on image Click
    const handleImageClick = () => {
        setShowModal(true);
    };
    
    // Cancel model on click outside
    const cancelModel = () => {
        setShowModal(false);
    };
    const stopPropagation = (e) => {
        e.stopPropagation();
    };
        
    const imagesWithUrl = images.filter(
        (image) => typeof image.url === 'string' && image.url !== '',
    );

    /** @todo Add "click to expand" feature. */
    return <section
        className={'product-gallery--container'}>
        {/** @todo Load all images in a div. */}
        {/** @todo Switch image position instead of changing the src. */}
        <ParallaxModel
            show={showModal}
            index={activeIndex}
            onClose={cancelModel}
            onClick={stopPropagation}
            productTitle={product.title}
            images={images}
        />
        <div

        
            className={'product-gallery--viewer'}>
            {imagesWithUrl.length < 1 ? <BsImage
                size={'500px'}
                fill={'#d3d3d3'} /> : <ZoomableResponsiveImage
                hoverMagnify={true}
                onClick={handleImageClick}
                imageUrl={imagesWithUrl[activeIndex].url}
                imageAlt={imagesWithUrl[activeIndex].altText || ''}
                mobileSize={'282px'}
                desktopSize={'500px'}></ZoomableResponsiveImage>}
        </div>
        <div
            className={'product-gallery--navigation'}>
            {imagesWithUrl.map((image, index) => <button
                key={index}
                className={`product-gallery--thumbnail-button${activeIndex === index ? ' active' : ''}`}
                onClick={() => setActiveIndex(index)}
            >
                <ResponsiveImage
                    imageUrl={image.url}
                    imageAlt={image.altText || ''}
                    mobileSize={'75px'}
                    desktopSize={'75px'}></ResponsiveImage>
                    
            </button>)}
        </div>
    </section>;
};

ProductGallery.propTypes = {
    product: PropTypes.shape({
        title: PropTypes.string,
        Images: PropTypes.array,
    }),
    onImageClick: PropTypes.func,
    images: PropTypes.arrayOf(PropTypes.shape({
        altText: PropTypes.string,
        Attachment: PropTypes.shape({
            localPath: PropTypes.string.isRequired,
        }),
    })),
};

export default ProductGallery;